import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const LogoLinkContainer = styled(Link)`
	color: none;
	text-decoration: none;
	background: none;
	padding-left: 15px;

	img {
		height: 5rem;
		width: auto;
	}
`;
